import { useEffect, useRef } from 'react';
import type { StoryModel } from './story-model';
import type { TimelinePositionEngine } from './use-timeline-position';

/**
 * Bevarer semantisk tidspunkt når story-modellen bygges på nytt (f.eks. ny periode endrer skalaen).
 * Uten dette ville posisjonsnummeret klemmes, men vise et annet tidspunkt på tidslinjen.
 */
export function usePreserveTimelineEpoch(model: StoryModel, engine: TimelinePositionEngine): void {
  const modelRef = useRef(model);
  const didMountRef = useRef(false);

  useEffect(() => {
    const previous = modelRef.current;
    modelRef.current = model;
    if (!didMountRef.current) {
      didMountRef.current = true;
      return;
    }
    if (previous === model) return;

    const epochMs = previous.scale.toTime(engine.get());
    const nextPosition = model.scale.toPosition(epochMs);
    engine.setTarget(nextPosition);
  }, [engine, model]);
}
